import { render, staticRenderFns } from "./RouterApp.vue?vue&type=template&id=25e25854&"
var script = {}
import style0 from "./RouterApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports